/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBillingCheckoutSession200Response
 */
export interface CreateBillingCheckoutSession200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateBillingCheckoutSession200Response
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBillingCheckoutSession200Response
     */
    url?: string;
}

/**
 * Check if a given object implements the CreateBillingCheckoutSession200Response interface.
 */
export function instanceOfCreateBillingCheckoutSession200Response(value: object): value is CreateBillingCheckoutSession200Response {
    return true;
}

export function CreateBillingCheckoutSession200ResponseFromJSON(json: any): CreateBillingCheckoutSession200Response {
    return CreateBillingCheckoutSession200ResponseFromJSONTyped(json, false);
}

export function CreateBillingCheckoutSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBillingCheckoutSession200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function CreateBillingCheckoutSession200ResponseToJSON(json: any): CreateBillingCheckoutSession200Response {
    return CreateBillingCheckoutSession200ResponseToJSONTyped(json, false);
}

export function CreateBillingCheckoutSession200ResponseToJSONTyped(value?: CreateBillingCheckoutSession200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'url': value['url'],
    };
}

